var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-0 m-0",attrs:{"fluid":""}},[_c('header',{staticClass:" m-3  "},[_c('m-nav-301',{staticClass:"header-rounded",attrs:{"id":"nav301"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }